import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

export default function NewSource(props) {
    const [container, setContainer] = useState(document.getElementById('news-container'));

    useEffect(() => {
        const listener = () => setContainer(document.getElementById('news-container'));

        window.addEventListener('news-container-ready', listener);

        return () => window.removeEventListener('news-container-ready', listener);
    }, []);

    if (container == null) {
        return null;
    }

    return ReactDOM.createPortal(
        <>
            <iframe id={'iframe-prematch-home-news'} src={props.src} />
        </>
        , container
    );
}
